module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as4909-a028a8148b0a4c74dbbf1bd9ae4de063.jpg";